<template>
    <div class="accordion container shadow p-4 mb-4 mt-4" id="accordionExample">
        <div class="accordion-item" style="margin-bottom:5px">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#prodotti" aria-expanded="true" aria-controls="#prodotti">
                    Listino Prodotti
                </button>
            </h2>
            <div id="prodotti" class="accordion-collapse shadow collapse" aria-labelledby="headingOne">
                <div class="accordion-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped align-middle text-center">
                            <thead class="table-light">
                                <tr>
                                    <td><input type="text" v-model="searchProd" placeholder="Cerca.."></td>
                                    <td></td>
                                </tr>
                            </thead>
                        </table>
                    </div>


                    <div v-for="product in products" :key="product.id">
                        <div
                            v-if="(searchProd == '') || (searchProd && product.prodName.toLowerCase().includes(searchProd.toLowerCase()))">
                            <p style="text-align:start">{{ product.prodName }}</p>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped align-middle text-center">
                                    <thead class="table-light">
                                        <tr>
                                            <th>Confezione</th>
                                            <th>Prezzo Listino</th>
                                            <th>Prezzo Agente</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="variation in product.subProds" :key="variation.Ar_CodArt">
                                            <td>{{ variation.packaging_label }}</td>
                                            <td>{{ variation.listingPrice }} {{ product.listingCurrency }}</td>
                                            <td><input type="number" v-model="variation.price" step="0.01" class="w-50">
                                            </td>
                                            <td>
                                                <button class="btn btn-danger" v-if="variation.isAgentPrice"
                                                    @click="resetPrice(variation.id, variation.price)">Reset prezzo
                                                    listino</button>
                                                <button class="btn btn-danger" v-else disabled>Reset prezzo
                                                    listino</button>
                                                <button class="btn btn-success"
                                                    @click="updatePrice(variation.id, variation.price)">Salva</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingOrdini">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOrdini" aria-expanded="false" aria-controls="collapseOrdini">
                    Lista Preventivi Salvati
                </button>
            </h2>
            <div id="collapseOrdini" class="accordion-collapse collapse shadow" aria-labelledby="headingOrdini">
                <div class="accordion-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col">Data</th>
                                    <th scope="col">Sistema</th>
                                    <th scope="col">Cliente</th>
                                    <th scope="col" class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="order in orders" :key="order.id">
                                    <td>{{ new Date(order.date).toLocaleDateString() }}</td>
                                    <td>{{ order.system_name }} - {{ order.base_name }}</td>
                                    <td>{{ order.name }}</td>
                                    <td class="text-end">
                                        <button class="btn btn-success btn-sm"
                                            @click="selectOrder(order.id);">Dettagli</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingClienti">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#clienti" aria-expanded="false" aria-controls="clienti">
                    Lista Clienti
                </button>
            </h2>

            <div id="clienti" class="accordion-collapse collapse shadow" aria-labelledby="headingClienti"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">

                    <!-- Add New Button (aligned right) -->
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="selectedCustomer = {}; modCliente.show()">+
                            Nuovo</button>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th><input type="text" v-model="searchCust" placeholder="Cerca.."></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Telefono</th>
                                    <th>Città</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="customer in customers" :key="customer.id">
                                    <template v-if="searchCust=='' || customer.name.toLowerCase().includes(searchCust.toLowerCase())">
                                    <td>{{ customer.name }}</td>
                                    <td>{{ customer.email }}</td>
                                    <td>{{ customer.phone }}</td>
                                    <td>{{ customer.city }}</td>
                                    <td><button class="btn btn-success btn-sm"
                                            @click="selectCustomer(customer)">Dettagli</button></td>
                                     </template>       
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>


        <div class="accordion-item" style="margin-bottom:5px">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#configurazioni" aria-expanded="true" aria-controls="#configurazioni">
                    Cambio Password
                </button>
            </h2>
            <div id="configurazioni" class="accordion-collapse shadow collapse" aria-labelledby="headingOne">
                <div class="accordion-body">
                    <div class="mb-3">
                        <div class="mb-3">
                            <label for="nome" class="form-label">Password Attuale</label>
                            <input v-model="oldPassword" type="password" id="oldPassword" name="oldPassword"
                                class="form-control" required>
                        </div>
                        <div class="mb-3">
                            <label for="nome" class="form-label">Nuova Password</label>
                            <input v-model="newPassword" type="password" id="newPassword" name="newPassword"
                                class="form-control" required>
                        </div>
                        <button style="float:left" class="btn btn-success" @click="resetPassword()">Salva</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div id="" class="modal modal-xl fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        ref="modalCliente">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow p-3 mb-5" v-if="!selectedCustomer.id">
                <div class="modal-header">
                    Aggiungi un Cliente
                </div>
                <div class="modal-body" style="display:flex;justify-content: center;">
                    <form style="width:500px">
                        <div class="mb-3">
                            <label for="nome" class="form-label">Nome</label>
                            <input v-model="newCustomer.name" type="text" id="username" name="nome" class="form-control"
                                required>
                        </div>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input v-model="newCustomer.email" type="email" id="email" name="email" class="form-control"
                                required>
                        </div>
                        <div class="mb-3">
                            <label for="telefono" class="form-label">Telefono</label>
                            <input v-model="newCustomer.phone" type="phone" id="telefono" name="telefono"
                                class="form-control" required>
                        </div>
                        <div class="mb-3">
                            <label for="citta" class="form-label">Città</label>
                            <input v-model="newCustomer.city" type="text" id="citta" name="citta" class="form-control"
                                required>
                        </div>
                        <button type="button" class="btn btn-success w-100" @click="postNewCustomer()">Salva</button>
                    </form>
                </div>
            </div>
            <div class="modal-content shadow p-3 mb-5" v-else>
                <div class="modal-header">
                    Dettagli Cliente
                </div>
                <div class="modal-body" style="display:flex;justify-content: center;">
                    <form style="width:500px">
                        <div class="mb-3">
                            <label for="nome" class="form-label">Nome</label>
                            <input v-model="selectedCustomer.name" type="text" id="username" name="nome"
                                class="form-control" required>
                        </div>
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input v-model="selectedCustomer.email" type="email" id="email" name="email"
                                class="form-control" required>
                        </div>
                        <div class="mb-3">
                            <label for="telefono" class="form-label">Telefono</label>
                            <input v-model="selectedCustomer.phone" type="phone" id="telefono" name="telefono"
                                class="form-control" required>
                        </div>
                        <div class="mb-3">
                            <label for="citta" class="form-label">Città</label>
                            <input v-model="selectedCustomer.city" type="text" id="citta" name="citta"
                                class="form-control" required>
                        </div>

                    </form>
                </div>
                <div class="modal-footer border-0 d-flex justify-content-end">
                    <button type="button" class="btn btn-success" @click="updateCustomer(selectedCustomer)">
                        Salva
                    </button>
                    <button type="button" class="btn btn-danger" @click="deleteCustomer(selectedCustomer.id)">
                        Elimina
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal modal-xl fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        ref="modalOrder">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow p-4">

                <!-- Modal Header -->
                <div class="modal-header border-0">
                    <h5 class="modal-title">Dettagli Ordine</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">
                    <div class="row g-4">

                        <!-- General Order Info -->
                        <div class="col-12 col-lg-5">
                            <div class="p-3 border rounded bg-light h-100">
                                <h6 class="mb-3 text-muted">Informazioni Generali</h6>
                                <ul class="list-unstyled mb-0">
                                    <li><strong>Data:</strong> {{ new Date(selectedOrder.date).toLocaleDateString() }}
                                    </li>
                                    <li><strong>Sistema:</strong> {{ selectedOrder.system_name }}</li>
                                    <li><strong>Superficie:</strong> {{ selectedOrder.base_name }}</li>
                                    <li><strong>Cliente:</strong> {{ selectedOrder.name }}</li>
                                    <li><strong>MQ:</strong> {{ selectedOrder.mq }}</li>
                                    <li><strong>Manodopera:</strong> {{ selectedOrder.manodopera }}</li>
                                    <li><strong>Sconto totale:</strong> {{ selectedOrder.discount }}%</li>
                                    <li><strong>Totale:</strong> {{selectedOrder.currency}} {{ selectedOrder.total }}</li>
                                    <li v-if="selectedOrder.orderNotes && selectedOrder.orderNotes.length>0"><strong>Note:</strong> {{ selectedOrder.orderNotes }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- Product List -->
                        <div class="col-12 col-lg-7">
                            <div class="p-3 border rounded h-100">
                                <h6 class="mb-3 text-muted">Prodotti Inclusi</h6>

                                <div v-for="(prodotto, i) in selectedOrder.products" :key="i" class="mb-4">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <strong>{{ prodotto.product_name }}</strong>
                                        <span class="text-success fw-bold">Totale: {{ prodotto.total.toFixed(2) }}
                                            {{selectedOrder.currency}}</span>
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped align-middle">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Confezione</th>
                                                    <th>Quantità</th>
                                                    <th>Sconto</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="variation in prodotto.variations" :key="variation.id">
                                                    <td>{{ variation.packaging_label }}</td>
                                                    <td>{{ variation.quantity }}</td>
                                                    <td>{{ variation.discount }}%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <!-- Modal Footer -->
                <div class="modal-footer border-0 d-flex justify-content-end">
                    <button type="button" class="btn btn-success" @click="printPDF(selectedOrder)">
                        Stampa PDF
                    </button>
                    <button type="button" class="btn btn-danger" @click="deleteOrder(selectedOrder.id)">
                        Elimina Ordine
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap'
import { useLoading } from 'vue-loading-overlay'
import { onMounted, ref, computed } from 'vue'
import orderMethods from '../api/resources/orderMethods'
import customersMethods from '@/api/resources/customersMethods'
import productMethods from '../api/resources/productMethods'
import usersMethods from '@/api/resources/usersMethods'
export default {
    name: "AgentView",
    emits: ['alert'],
    setup(_, { emit }) {
        var modCliente = ref(Modal);
        var modOrder = ref(Modal);
        const modalCliente = ref(null);
        const modalOrder = ref(null);
        const orders = ref([]);
        const customers = ref([]);
        const newCustomer = ref({
            name: "",
            email: "",
            phone: "",
            city: ""
        });
        const products = ref([]);

        const selectedOrder = ref({})
        const selectedCustomer = ref({});

        const oldPassword = ref("");
        const newPassword = ref("");

        const searchProd = ref("");
        const searchCust = ref("");

        var loader = useLoading();

        onMounted(async () => {
            init()
        })

        async function init() {
            modCliente.value = new Modal(modalCliente.value)
            modOrder.value = new Modal(modalOrder.value)
            let dataO = await orderMethods.getOrders();
            let dataC = await customersMethods.getCustomers();
            let dataP = await productMethods.getProducts();
            orders.value = dataO.data;
            customers.value = dataC.data;
            products.value = dataP.data;
            //console.log(orders.value)
        }

        async function postNewCustomer() {
            let lod = loader.show()
            await customersMethods.postCustomer(newCustomer.value);
            modCliente.value.hide();
            newCustomer.value = {
                name: "",
                email: "",
                phone: "",
                city: ""
            }
            let dataC = await customersMethods.getCustomers();
            customers.value = dataC.data;
            lod.hide();
            emit('alert', { message: "Cliente Creato", color: "green" });
        }
        async function updateCustomer(data) {
            let lod = loader.show()
            await customersMethods.updateCustomer(data);
            modCliente.value.hide();
            let dataC = await customersMethods.getCustomers();
            customers.value = dataC.data;
            lod.hide();
            emit('alert', { message: "Cliente Aggiornato", color: "green" });
        }

        async function getOrder(id) {
            let dataO = await orderMethods.getOrders(id);
            selectedOrder.value = dataO.data;
        }

        async function selectOrder(id) {
            modOrder.value.show();
            let dataO = await orderMethods.getOrders(id);
            let products_names = [];
            let groupedProducts = [];
            dataO.data.products.forEach((product) => {
                if (!products_names.includes(product.product_name)) {
                    products_names.push(product.product_name)
                    groupedProducts.push({
                        product_name: product.product_name,
                        discount: product.discount,
                        total: 0,
                        variations: []
                    })
                }
            })
            dataO.data.products.forEach((productVariation) => {
                groupedProducts.forEach((product) => {
                    if (productVariation.product_name == product.product_name) {
                        product.total += productVariation.price * productVariation.quantity - (productVariation.price * productVariation.quantity * productVariation.discount / 100)
                        product.variations.push(productVariation);
                    }
                })
            })
            dataO.data.products = groupedProducts;
            selectedOrder.value = dataO.data;
        }
        async function deleteOrder(id) {
            let lod = loader.show()
            await orderMethods.deleteOrder(id);
            let dataO = await orderMethods.getOrders();
            orders.value = dataO.data;
            modOrder.value.hide()
            lod.hide()
            emit('alert', { message: "Ordine Eliminato!", color: "green" });
        }

        async function updatePrice(variationId, price) {
            let lod = loader.show();
            let obj = {
                variationId: variationId,
                price: price
            }
            await productMethods.updatePrice(obj);
            await init();
            lod.hide();
            emit('alert', { message: "Prezzo Aggiornato!", color: "green" });
        }

        async function resetPrice(variationId, price) {
            let lod = loader.show();
            let obj = {
                variationId: variationId,
                price: price
            }
            await productMethods.resetPrice(obj);
            await init();
            lod.hide();
            emit('alert', { message: "Prezzo Aggiornato!", color: "green" });
        }

        async function printPDF(order) {
            let obj = {
                date: order.date,
                MQInput: order.mq,
                systemInput: order.system_name,
                baseInput: order.base_name,
                customerInput: order.name,
                finalResult: order.products,
                orderNotes: order.orderNotes,
                customerInput: {
                    name: order.name
                },
                systemInput: {
                    system_name: order.system_name
                },
                baseInput: {
                    base_name: order.base_name
                },
                manodopera: order.manodopera,
                total: order.total,
                discount: order.discount,
                currency: order.currency
            }
            return orderMethods.generatePDF(obj);
        }

        function selectCustomer(obj) {
            selectedCustomer.value = obj;
            modCliente.value.show()
        }

        async function deleteCustomer(id) {
            let lod = loader.show()
            await customersMethods.deleteCustomer(id);
            modCliente.value.hide();
            let dataC = await customersMethods.getCustomers();
            customers.value = dataC.data;
            lod.hide();
            emit('alert', { message: "Cliente Eliminato", color: "green" });
        }

        async function resetPassword() {
            if (oldPassword.value == "") {
                emit('alert', { message: "Inserire password attuale", color: "red" });
                return;
            }
            if (newPassword.value == "") {
                emit('alert', { message: "Inserire nuova password", color: "red" });
                return;
            }
            if(newPassword.value.length < 8){
                emit('alert', { message: "La password deve contenere almeno 8 caratteri", color: "red" });
                return;
            }
            let obj = {
                oldPassword: oldPassword.value,
                newPassword: newPassword.value
            }
            let res = await usersMethods.resetPasswordFromLogged(obj);
            if (res.messages[0].message == "success") {
                emit('alert', { message: "Password aggiornata", color: "green" });
                return;
            }
            emit('alert', { message: "Errore! controlla password inserita", color: "red" });
            return;
        }

        return {
            modCliente, modalCliente, orders, customers, newCustomer, postNewCustomer,
            selectedOrder, selectedCustomer, modOrder, modalOrder, getOrder, selectOrder, deleteOrder,
            products, updatePrice, resetPrice, printPDF, deleteCustomer, selectCustomer, updateCustomer,
            oldPassword, newPassword, resetPassword,
            searchProd,searchCust
        }
    }
}
</script>